import request from '@/utils/http'

let profixUrl = 'userservice'
/**
 * 微信公众号扫码登录
 * @param {
 *   code: window.location.href,
 *   platform: 'PC',
 * } params
 * @returns
 */
export const wechatQrcode = params =>
    request({
        url: `/${profixUrl}/auth/wechat/qrcode/USER_LOGIN`,
        method: 'get',
        params,
    })

// 获取微信扫码状态
export const getScanResult = uuid =>
    request({
        url: `/${profixUrl}/auth/wechat/getScanResult/` + uuid,
        method: 'get',
    })

// 获取图片验证码
export const captchaImage = () =>
    request({
        url: `/${profixUrl}/auth/captchaImage`,
        method: 'get',
    })

// 账号密码登录
export const login = data =>
    request({
        url: `/${profixUrl}/auth/login`,
        method: 'post',
        data,
    })

// 获取短信验证码
export const sendMsg = params =>
    request({
        url: `/${profixUrl}/auth/sendMsg`,
        method: 'get',
        params,
    })

// 短信验证码登录
export const phoneLogin = data =>
    request({
        url: `/${profixUrl}/auth/phoneLogin`,
        method: 'post',
        data,
    })

// 手机号注册
export const phoneRegister = data =>
    request({
        url: `/${profixUrl}/auth/phoneRegister`,
        method: 'post',
        data,
    })

// 绑定手机号
export const phoneValidate = data =>
    request({
        url: `/${profixUrl}/auth/user/profile/phoneValidate`,
        method: 'post',
        data,
        headers: {
            Platform: 'PC',
            Authorization: 'Bearer ' + data.token,
        },
    })

// 获取用户信息
export const getInfo = token =>
    request({
        url: `/${profixUrl}/auth/getInfo`,
        method: 'get',
        headers: {
            Platform: 'PC',
            Authorization: 'Bearer ' + token,
        },
    })

// 退出登录
export const logout = () => {
    return request({
        url: `/${profixUrl}/auth/loginOut`,
        method: 'post',
    })
}


// 获取banner
// 退出登录
export const getBannerList = () => {
    return request({
        url: `/api/portal/banner/list?type=7`,
        method: 'post',
    })
}